import {ValetHttp} from "../../../http/ValetHttp";

export default {
    async setTechnicians({commit}) {
        const technicians = await ValetHttp.getTechnicians().then(result => result.data);
        commit('setTechnicians', technicians);
    },
    setActiveTechnician({commit}, activeTechnician) {
        commit('setActiveTechnician', activeTechnician);
    },
    setManageTechnicianDialog({commit}, status) {
        commit('setManageTechnicianDialog', status);
    },
    setManageDeleteTechnicianDialog({commit}, status) {
        commit('setManageDeleteTechnicianDialog', status);
    }
}
